import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WysiwygLiteComponent } from './wysiwyg-lite.component';

@NgModule({
  declarations: [WysiwygLiteComponent],
  imports: [CommonModule],
  exports: [WysiwygLiteComponent],
})
export class WysiwygLiteModule {}
